const DB_NAME = "stishopdb";
const STORAGE_NAME = "products";
const DB_VERSION = 1;
let DB;

const database = {
	async getDb() {
		return new Promise((resolve, reject) => {
			if (DB) {
				return resolve(DB);
			}
			const request = window.indexedDB.open(DB_NAME, DB_VERSION);

			request.onerror = e => {
				console.log("Error opening db", e);
				reject("Error");
			}

			request.onsuccess = e => {
				DB = e.target.result;
				resolve(DB);
			}

			request.onupgradeneeded = e => {
				let db = e.target.result;
				db.createObjectStore(STORAGE_NAME, { keyPath: "id" });
			}
		});
	},
	async deleteProduct(id) {
		const db = await this.getDb();

		return new Promise(resolve => {
			const trans = db.transaction([STORAGE_NAME], "readwrite");
			trans.oncomplete = () => {
				resolve();
			}

			const store = trans.objectStore(STORAGE_NAME);
			store.delete(id);
		});
	},
	async getProducts() {
		let db = await this.getDb();
		const products = [];

		return new Promise(resolve => {
			let trans = db.transaction([STORAGE_NAME], "readonly");
			trans.oncomplete = () => {
				resolve(products);
			}

			const store = trans.objectStore(STORAGE_NAME);

			store.openCursor().onsuccess = e => {
				const cursor = e.target.result;
				if (cursor) {
					products.push(cursor.value);
					cursor.continue();
				}
			}
		});
	},
	async saveProduct(product) {
		let db = await this.getDb();

		return new Promise(resolve => {
			let trans = db.transaction([STORAGE_NAME], 'readwrite');
			trans.oncomplete = () => {
				resolve();
			}

			let store = trans.objectStore(STORAGE_NAME);
			store.put(product);
		});
	}
};

export default database;